/**
 * Collection Content Insert - Interactive features
 * Handles: entrance animations, parallax scrolling, countdown timers
 */
(function () {
  function initAnimations() {
    var blocks = document.querySelectorAll('.collection-content-insert[data-animation]');
    if (!blocks.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    blocks.forEach(function (block) { observer.observe(block); });
  }

  function initParallax() {
    var els = document.querySelectorAll('.collection-content-insert__media--parallax img');
    if (!els.length) return;
    var ticking = false;
    function update() {
      els.forEach(function (img) {
        var container = img.closest('.collection-content-insert');
        if (!container) return;
        var rect = container.getBoundingClientRect();
        var wh = window.innerHeight;
        if (rect.bottom < 0 || rect.top > wh) return;
        var progress = (wh - rect.top) / (wh + rect.height);
        img.style.transform = 'translateY(' + ((progress - 0.5) * 60) + 'px)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initCountdowns() {
    var els = document.querySelectorAll('.collection-content-insert__countdown[data-countdown-date]');
    if (!els.length) return;
    function tick(el) {
      var target = new Date(el.dataset.countdownDate);
      var diff = target - new Date();
      if (diff <= 0) {
        el.innerHTML = '<span class="collection-content-insert__countdown-expired">' +
          (el.dataset.expiredText || 'Tiden har gått ut') + '</span>';
        return false;
      }
      var d = Math.floor(diff / 864e5);
      var h = Math.floor((diff % 864e5) / 36e5);
      var m = Math.floor((diff % 36e5) / 6e4);
      var s = Math.floor((diff % 6e4) / 1e3);
      var vals = el.querySelectorAll('.collection-content-insert__countdown-value');
      if (vals[0]) vals[0].textContent = String(d).padStart(2, '0');
      if (vals[1]) vals[1].textContent = String(h).padStart(2, '0');
      if (vals[2]) vals[2].textContent = String(m).padStart(2, '0');
      if (vals[3]) vals[3].textContent = String(s).padStart(2, '0');
      return true;
    }
    els.forEach(function (el) {
      if (tick(el)) setInterval(function () { tick(el); }, 1000);
    });
  }

  function init() { initAnimations(); initParallax(); initCountdowns(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
